<template>
  <div>
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div style="padding-bottom: 10px;">
      <Button type="primary" icon="ios-search" @click="()=>{this.isShowModal = true}">检索条件</Button>
    </div>
    <Table ref="selection" :data="showData" :columns="showColumns" stripe border></Table>
    <Page
      style="padding-top: 10px;"
      :current="currentPage"
      :total="dataCount"
      :page-size="pageSize"
      show-sizer
      show-total
      @on-change="changePage"
      @on-page-size-change="changePageSize"
    ></Page>

    <!-- 模态框 -->
    <Modal v-model="isShowModal" :mask-closable="false" width="380">
      <p slot="header" style="color:#0066FF;text-align:center">
        <Icon type="md-create" />
        <span>检索条件</span>
      </p>
      <div style="text-align:center">
        <CheckboxGroup v-model="selectedCondition" class="check_grop">
          <div>
            <Row>
              <Col span="12">
                <Checkbox label="pushId">
                  <span>推送编号</span>
                </Checkbox>
              </Col>
              <Col span="12">
                <InputNumber
                  v-model="infoPushModelExample.pushId"
                  :min="1"
                  :precision="0"
                  placeholder="请输入推送编号"
                  style="width: 150px"
                />
              </Col>
            </Row>
          </div>
          <div>
            <Row>
              <Col span="12">
                <Checkbox label="pushKeyword2Content">
                  <span>设备编号</span>
                </Checkbox>
              </Col>
              <Col span="12">
                <Input
                  v-model="infoPushModelExample.pushKeyword2Content"
                  placeholder="请输入设备编号"
                  style="width: 150px"
                />
              </Col>
            </Row>
          </div>
          <div>
            <Row>
              <Col span="12">
                <Checkbox label="pushState">
                  <span>推送状态</span>
                </Checkbox>
              </Col>
              <Select
                v-model="infoPushModelExample.pushState"
                style="width:150px"
                placeholder="请选择推送状态"
              >
                <Option
                  v-for="(value, key) in pushStateSelectDate"
                  :key="key"
                  :value="value"
                  :label="key"
                ></Option>
              </Select>
            </Row>
          </div>
          <div>
            <Row>
              <Col span="12">
                <Checkbox label="pushDateRange">
                  <span>时间区间</span>
                </Checkbox>
              </Col>
              <Col span="12">
                <Tooltip
                  transfer
                  placement="top"
                  :disabled="infoPushModelExample.pushDateRange == undefined || infoPushModelExample.pushDateRange[0] == ''"
                >
                  <div
                    slot="content"
                    v-if="infoPushModelExample.pushDateRange && infoPushModelExample.pushDateRange[0]"
                  >
                    <span>{{dateFtt('yyyy-MM-dd hh:mm:ss',infoPushModelExample.pushDateRange[0])}}</span>
                    <br />
                    <span style="margin-left:50%">~</span>
                    <br />
                    <span>{{dateFtt('yyyy-MM-dd hh:mm:ss',infoPushModelExample.pushDateRange[1])}}</span>
                  </div>
                  <DatePicker
                    v-model="infoPushModelExample.pushDateRange"
                    type="datetimerange"
                    split-panels
                    placeholder="请选择时间区间"
                    :options="options"
                    style="width: 150px"
                  ></DatePicker>
                </Tooltip>
              </Col>
            </Row>
          </div>
          <div>
            <Row>
              <Col span="12">
                <Checkbox label="pushType">
                  <span>推送类型</span>
                </Checkbox>
              </Col>
              <Col span="12">
                <Select
                  v-model="infoPushModelExample.pushType"
                  style="width:150px"
                  placeholder="请选择推送类型"
                >
                  <Option
                    v-for="(value, key) in pushTypeSelectDate"
                    :key="key"
                    :value="value"
                    :label="key"
                  ></Option>
                </Select>
              </Col>
            </Row>
          </div>
        </CheckboxGroup>
      </div>
      <div slot="footer">
        <Button type="info" size="large" long @click="searchByCondition">检索</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "record_msg",
  created() {
    this.showColumns[6]["data"] = this.pushStateSelectDate;
    this.showColumns[2]["data"] = this.pushTypeSelectDate;
    this.showPage();
  },
  data() {
    return {
      selectedCondition: [],
      isShowModal: false,
      isSpinShow: false,
      currentPage: 1,
      dataCount: 0,
      pageSize: 10,
      showData: [],
      showColumns: [
        {
          title: "推送编号",
          key: "pushId"
        },
        {
          title: "设备编号",
          key: "pushKeyword2Content"
        },
        {
          title: "推送类型",
          key: "pushType",
          render: function(h, params) {
            return h("div", keyFormat(this.row.pushType, this.column.data));
          }
        },
        {
          title: "推送内容",
          key: "pushRemarkContent",
          width: (document.body.clientWidth * 380) / 1366,
          render: function(h, params) {
            return h("div", pushContentFormat(this.row.pushRemarkContent));
          }
        },
        {
          title: "推送时间",
          key: "pushDate",
          render: function(h, params) {
            return h(
              "div",
              global.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.row.pushDate))
            );
          }
        },
        {
          title: "推送对象",
          key: "pushTarget"
        },
        {
          title: "推送状态",
          key: "pushState",
          render: function(h, params) {
            return h("div", keyFormat(this.row.pushState, this.column.data));
          }
        }
      ],
      infoPushModel: {},
      infoPushModelExample: {},
      pushStateSelectDate: {
        未绑定移动端: 0,
        推送成功: 1,
        用户拒收: 2,
        系统错误: 3,
        微信未返回消息: -1,
        微信接口失效: -2
      },
      pushTypeSelectDate: {
        故障报警推送: "command",
        消息发布推送: "textMsg",
        工单推送: "order",
        安检到期推送: "commandSafety",
        燃气用具到期推送: "gasAppliances",
        nb通讯异常推送: "communicationOverDue"
      },
      options: {
        shortcuts: [
          {
            text: "近一周",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            }
          },
          {
            text: "近一月",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            }
          },
          {
            text: "近三月",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            }
          }
        ]
      }
    };
  },
  methods: {
    dateFtt(fmt, date) {
      return global.dateFtt(fmt, date);
    },
    changePage(index) {
      this.currentPage = index;
      this.showPage();
    },
    changePageSize(size) {
      this.pageSize = size;
      this.showPage();
    },
    showPage() {
      var that = this;
      that.isSpinShow = true;
      $.ajax({
        url:
          "/api/baseInfo/getInfoPushPage?page=" +
          this.currentPage +
          "&pageAmount=" +
          this.pageSize,
        contentType: "application/json",
        type: "post",
        dataType: "json",
        data: JSON.stringify(that.infoPushModel),
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          that.showData = data.body.resultList;
          // that.showData.map(item=>{
          //   
          //   if(item.pushType == "command"){
          //     item.meter = item.pushKeyword1Content.split(",")[0];
          //   } else if(item.pushType == "commandSafety"){
          //     item.meter = item.pushRemarkContent.split("\n")[0].substring(5);
          //   } else if(item.pushType == "communicationOverDue"){
          //     item.meter = item.pushKeyword1Content.split(",")[0];
          //   } else if(item.pushType == "gasAppliances"){
          //     
          //   } else if(item.pushType == "order"){
          //     
          //   } else {
          //     item.meter = "";
          //   }
          // });
          that.dataCount = data.body.amount;
          that.isSpinShow = false;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
    searchByCondition() {
      this.infoPushModel = {};
      this.selectedCondition.map(item => {
        this.infoPushModel[item] = this.infoPushModelExample[item];
      });
      this.isShowModal = false;
      this.showPage();
    }
  }
};

/**************************************格式化key************************************/
function keyFormat(param, obj) {
  for (var key in obj) {
    if (obj[key] == param) {
      return key;
    }
  }
}

/**************************************格式化推送内容************************************/
function pushContentFormat(pushContent) {
  if (pushContent != null) {
    return pushContent.split("\n").reverse()[0];
  }
}

/*----------------------给系统对象加一个扩展函数： ------------------*/
Array.prototype.contains = function(obj) {
  var index = this.length;
  while (index--) {
    if (this[index] === obj) {
      return true;
    }
  }
  return false;
};
</script>

<style>
.ivu-table td,
.ivu-table th {
  min-width: 0;
  height: 30px;
  box-sizing: border-box;
  text-align: center;
  text-overflow: ellipsis;
  vertical-align: middle;
  border-bottom: 1px solid #e8eaec;
}

.check_grop div {
  margin-bottom: 1px;
}
</style>
